import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Seo from "@/components/Seo";
import B2BForm from "@/components/B2BForm";
import { PageLead } from "@/components/PageLead";
import ChoiceBlock from "@/components/ChoiceBlock";
import { useLang } from "@/i18n";
import { breadcrumbLd, organizationLd, serviceLd } from "@/lib/seo";

const Hosteleria = () => {
  const { lang, t } = useLang();

  return (
    <div className="bg-[#F5F1E8] overflow-x-hidden">
      <Seo
        title={t.seo.hosteleria.title}
        description={t.seo.hosteleria.description}
        path="/hosteleria"
        lang={lang}
        jsonLd={[
          organizationLd(),
          breadcrumbLd([
            { name: "Naguarà", path: "/" },
            { name: t.nav.horeca, path: "/hosteleria" },
          ]),
          serviceLd({
            name: t.seo.hosteleria.h1,
            description: t.seo.hosteleria.description,
            path: "/hosteleria",
          }),
        ]}
      />
      <Navbar />
      <div className="h-20 bg-[#422D28]" aria-hidden="true" />
      <main data-testid="page-hosteleria">
        <PageLead pageKey="hosteleria" title={t.seo.hosteleria.h1} />
        <B2BForm />
        <ChoiceBlock />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
};

export default Hosteleria;
